import { render } from "./PendingGroupManagerDocuments.vue?vue&type=template&id=be6539c6&scoped=true"
import script from "./PendingGroupManagerDocuments.vue?vue&type=script&lang=js"
export * from "./PendingGroupManagerDocuments.vue?vue&type=script&lang=js"

import "./PendingGroupManagerDocuments.vue?vue&type=style&index=0&id=be6539c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6539c6"]])

export default __exports__